<app-navbar-style-one></app-navbar-style-one>

<div class="section-title">
    <h2>Edit Post</h2>
</div>

<section class="contact-area">
    <div class="container">
        <div class="contact-inner-area">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="contact-form">
                        <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                            <div class="row">
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input required ngModel name="postTitle" type="text" #postTitle="ngModel"
                                            [ngModel]="details.postTitle" class="form-control custom-border"
                                            id="postTitle" placeholder="Post Title">

                                    </div>
                                </div>


                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group mb-3">
                                        <textarea required ngModel name="description" #description="ngModel"
                                            [ngModel]="details.postDesciption" class="form-control custom-border"
                                            id="description" rows="6" placeholder="Description"></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        Keywords
                                        <input required ngModel name="keywords" type="text" #keywords="ngModel"
                                            [ngModel]="details.keywords" class="form-control custom-border"
                                            id="keywords" placeholder="Keywords">

                                    </div>
                                </div>

                                <div class="col-lg-10 col-md-12">
                                    <button type="submit" class="default-btn" [class.disabled]="!contactForm.valid"><i
                                            class='bx bx-paper-plane'></i> UPDATE MAIN DETAILS</button>
                                </div>
                                 <div class="col-lg-2 col-md-12">
                                    <button type="submit" class="default-btn" style="background-color: red;" (click)="deletePost()" ><i
                                            class='bx bx-paper-plane'></i> DELETE</button>
                                </div>
                            </div>
                        </form>
                        <br>
                        <hr>
                        <h4>Update Main Image</h4>
                        <div class="row">
                            <div class="col-lg-5 col-md-12">
                                <div class="products-details-image">
                                    <a href="{{details.imageUrl}}" class="popup-btn">
                                        <img src="{{details.imageUrl}}" alt="image">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-7 col-md-12">
                                <div class="form-group mb-3">
                                    <input type="file" class="file-input" #fileUploadVehicleReg required
                                        accept=".jpg, .jpeg, .png" (change)="onFileSelectedVehicleReg($event)">
                                </div>
                                <button (click)="saveImageChanges()" class="default-btn"
                                    [class.disabled]="!contactForm.valid"><i class='bx bx-paper-plane'></i> Update
                                    Image</button>

                            </div>
                        </div>
                        <br>
                        <hr>
                        <h4>View Other Details</h4>
                        <br>

                        <div class="table-responsive">
                            <table class="table table-bordered table-striped">
                                <thead class="table-primary">
                                    <tr>
                                        <th>Title</th>
                                        <th>Description</th>
                                        <th>View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let obj of otherDetails">
                                        <td>{{ obj.title }}</td>
                                        <td>{{ obj.otherDescription }}</td>
                                        <td>
                                            <a [routerLink]="['/admin/edit-other-post-details', obj.id]"
                                                class="btn btn-sm btn-outline-primary">
                                                View
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-C8F6CSWD62"></script>
<script>
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());

    gtag('config', 'G-C8F6CSWD62');
</script>